<template>
  <div class="register">
    <div class="card register-card card-design">
      <div class="mobile-head">
        <img
          class="img-background-fade"
          src="../assets/spree/rutsche_aussen.jpg"
          alt="background"
        />
      </div>
      <div class="card-body">
        <div class="card-headline">
          <div class="logo logoStart" />
          <!--<img class="logo" src="../assets/logo.svg" alt="BlackJack" />-->
          <h3 class="custom-headline" v-text="$ml.get('title')"></h3>
          <div v-text="$ml.get('text')"></div>
          <LangChooser />
        </div>
        <div v-if="!isLoggedIn && token !== ''" class="card-input-wrapper">
          <div class="card-input-container">
            <!-- Nickname -->
            <div class="card-input-description" v-text="$ml.get('name')"></div>
            <b-input-group id="input-group-username">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <UserIcon title="Username" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="input-username"
                v-model.trim="username"
                :maxlength="20"
                :state="validUsername"
                aria-describedby="input-username-feedback"
                type="text"
                required
                placeholder="MaxMuster19"
                class="input-with-icon"
              ></b-form-input>
              <b-form-invalid-feedback id="input-username-feedback">
                <span v-text="$ml.get('validation')"></span>
              </b-form-invalid-feedback>
            </b-input-group>
            <hr class="card-hr" />
            <!-- Password -->
            <div
              class="card-input-description"
              v-text="$ml.get('labelPassword')"
            ></div>
            <b-input-group id="input-group-password" :state="validPassword">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <PasswordIcon title="Passwort" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="input-password"
                v-model.trim="password"
                :state="validPassword"
                :maxlength="4"
                aria-describedby="input-password-feedback"
                type="password"
                required
                :placeholder="$ml.get('placeholderCode')"
                class="input-with-icon"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input-password-feedback"
                v-text="$ml.get('validationPassword')"
              ></b-form-invalid-feedback>
            </b-input-group>
            <hr class="card-hr" />
            <!-- confirm password -->
            <div
              class="card-input-description"
              v-text="$ml.get('labelPassword2')"
            ></div>
            <b-input-group
              id="input-group-password-confirm"
              :state="confirmPassword"
            >
              <b-input-group-prepend>
                <span class="input-group-text">
                  <PasswordIcon title="Passwort wiederholen" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                id="input-password-confirm"
                v-model.trim="password2"
                :state="confirmPassword"
                :maxlength="4"
                aria-describedby="input-password2-feedback"
                type="password"
                required
                :placeholder="$ml.get('placeholderCode')"
                class="input-with-icon"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input-password2-feedback"
                v-text="$ml.get('validationPassword2')"
              ></b-form-invalid-feedback>
            </b-input-group>
            <hr class="card-hr" />
          </div>
        </div>
        <div v-if="!isLoggedIn && token !== ''" class="card-body-confirm">
          <div class="confirm-note" v-text="$ml.get('info')"></div>
          <button
            v-if="!isPending"
            :class="{
              disabled: username === '' || !confirmPassword || !validPassword,
            }"
            class="btn start-btn"
            @click="register"
            v-text="$ml.get('register')"
          ></button>
          <div v-else v-text="$ml.get('wait')"></div>
        </div>
        <div
          v-if="isLoggedIn || token === ''"
          class="card-body-confirm missing-token"
        >
          <div v-if="isLoggedIn">
            <div v-html="$ml.get('LoggedIn')"></div>
            <button class="btn" @click="logout">Logout</button>
          </div>
          <div v-else-if="token === ''" v-html="$ml.get('noToken')"></div>
        </div>
        <Footer />
      </div>
    </div>
    <Notification
      :show="notification.show"
      :title="notification.title"
      :text="notification.text"
      :error="notification.error"
      @okay="notification.show = false"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import UserIcon from "vue-material-design-icons/Account";
import PasswordIcon from "vue-material-design-icons/Lock";
import Notification from "../components/Notification";
import LangChooser from "../components/LangChooser";
import Footer from "../components/Footer";
import { MLBuilder } from "vue-multilanguage";

export default {
  name: "Register",
  components: {
    UserIcon,
    PasswordIcon,
    Notification,
    Footer,
    LangChooser,
  },
  data() {
    return {
      username: "",
      password: "",
      password2: "",
      token: "",
      gender: null,
      genderOptions: [
        { value: "D", text: "Divers" },
        { value: "M", text: "Männlich" },
        { value: "W", text: "Weiblich" },
      ],
      date: null,
      notification: {
        show: false,
        title: "",
        text: "",
        error: {},
      },
    };
  },
  computed: {
    ...mapGetters("authentication", ["isLoggedIn", "name", "isPending"]),
    validUsername() {
      let length = this.username.length;
      if (length === 0) {
        return null;
      } else return length >= 3;
    },
    validPassword() {
      let length = this.password.length;
      if (length === 0) {
        return null;
      } else if (length === 4) {
        const pattern = new RegExp("^[0-9]{4}");
        return pattern.test(this.password);
      } else {
        return false;
      }
    },
    confirmPassword() {
      if (this.password2 === "") {
        return null;
      } else return this.password === this.password2;
    },
    mlLoggedIn() {
      return new MLBuilder("loggedIn").with("name", this.username);
    },
  },
  mounted() {
    if (typeof this.$route.query.token !== "undefined") {
      this.token = this.$route.query.token;
    }
  },
  methods: {
    ...mapActions("authentication", ["login", "logout"]),
    async logMeIn() {
      try {
        await this.login({
          username: this.username,
          password: this.password,
        });
        this.username = "";
        this.password = "";
        this.$router.push({ name: "home" });
      } catch (e) {
        this.password = "";
        console.log(e);
      }
    },
    async register() {
      if (this.validUsername && this.confirmPassword && this.validPassword) {
        try {
          await this.axios.post("/api/register", {
            user_name: this.username,
            code: this.password,
            token: this.token,
            gender: this.gender,
            birthdate: this.date,
          });
          this.password2 = "";
          // auto login
          this.logMeIn();
        } catch (e) {
          if (typeof e.response !== "undefined") {
            this.notification.error = e.response;
            console.log(e.response.data);
            this.showNotification("", "");
          } else {
            this.e = {};
            this.showNotification(
              "Oops!",
              "Da ist etwas schief gelaufen. Bitte probiere es erneut!"
            );
            console.log(e);
          }
        }
      }
    },
    showNotification(title, text) {
      console.log("show msg called", title, text);
      this.notification.title = title;
      this.notification.text = text;
      this.notification.show = true;
    },
  },
};
</script>

<style scoped></style>
